// Upload file to S3 via server endpoint
export const uploadToS3 = async (file, userEmail) => {
  if (!file) return null

  const formData = new FormData()
  formData.append('file', file)

  if (userEmail) {
    formData.append('userEmail', userEmail)
  }

  try {
    const response = await fetch('/api/upload', {
      method: 'POST',
      body: formData,
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'Failed to upload file')
    }

    const data = await response.json()
    return data.url
  } catch (error) {
    console.error('Error uploading file:', error)
    throw error
  }
}
